'use strict';

exports.__esModule = true;
var DEBOUNCE_OPTIONS = exports.DEBOUNCE_OPTIONS = {
	trailing: true
};
var DEFAULT_FILTER_CLASS = exports.DEFAULT_FILTER_CLASS = 1;
var MIN_AUTOCOMPLETE_LENGTH = exports.MIN_AUTOCOMPLETE_LENGTH = 2;
var DEFAULT_WITHIN = exports.DEFAULT_WITHIN = 15;
var PAGE_SIZE = exports.PAGE_SIZE = 20;
var DEBOUNCE_RATE = exports.DEBOUNCE_RATE = 275;
var SCANS = exports.SCANS = 'scans';
var APPOINTMENTS = exports.APPOINTMENTS = 'appointments';
var HEALTH_CHECK = exports.HEALTH_CHECK = 'healthchecks';
var STRING_FILTER = exports.STRING_FILTER = 'stringFilter';
var MOMENT_FORMAT = exports.MOMENT_FORMAT = 'YYYY-MM-DD HH:mm:ssZ';
var LISTINGS_NEEDED = exports.LISTINGS_NEEDED = ['specialties', 'insurers', 'scansTreatmentGroups', 'healthChecksTreatmentGroups', 'languages'];


// WEBPACK FOOTER //
// ./components/search-page/lib/utils/constants.js